;var Info = function( chapter ) {

  var isOpen = false;
  var isInfoOpen = false;

  $( chapter ).find('.infoButton').on('click', function( e ) {
    if ( isOpen ) {
      close();
    } else {
      open();
    }
  });

  $( chapter ).find('.infoSizeButton').on('click', function( e ) {
    if ( isInfoOpen ) {
      closeSize();
    } else {
      openSize();
    }
  });

  $( chapter ).find('.infoWrapper').on('click', function( e ) { 
    if (e.target === e.currentTarget) {
      close();
    }
  });

  $( chapter ).find('.infoSizeWrapper').on('click', function( e ) { 
    if (e.target === e.currentTarget) {
      closeSize();
    }
  });

  $(window).on('navigationOpenEvent', function() {
    closeAll();
  });

  function open() {
    isOpen = true;
    isInfoOpen = false;

    $( chapter ).find( '.infoSizeContainer' ).removeClass( 'infoOpen' );
    $( chapter ).find( '.infoSizeButton' ).removeClass( 'infoOpen' );
    $( chapter ).find( '.infoSizeButton' ).removeClass( 'appear' );
    $( chapter ).find( '.infoSizeWrapper' ).removeClass( 'displayBlock' );

    $( chapter ).find( '.infoContainer' ).addClass( 'infoOpen' );
    $( chapter ).find( '.infoButton' ).addClass( 'infoOpen' );
    $( chapter ).find( '.infoWrapper' ).addClass( 'displayBlock' );



    // close bottom navigation
    Navigation.close();
  }

  function openSize() {
    isInfoOpen = true;
    isOpen = false;

    $( chapter ).find( '.infoContainer' ).removeClass( 'infoOpen' );
    $( chapter ).find( '.infoButton' ).removeClass( 'infoOpen' );
    $( chapter ).find( '.infoWrapper' ).removeClass( 'displayBlock' );

    $( chapter ).find( '.infoSizeContainer' ).addClass( 'infoOpen' );
    $( chapter ).find( '.infoSizeButton' ).addClass( 'infoOpen' );
    $( chapter ).find( '.infoSizeWrapper' ).addClass( 'displayBlock' );

    // close bottom navigation
    Navigation.close();
  }

  function close() {
    isOpen = false;

    $( chapter ).find( '.infoContainer' ).removeClass( 'infoOpen' );
    $( chapter ).find( '.infoButton' ).removeClass( 'infoOpen' );
    $( chapter ).find( '.infoWrapper' ).removeClass( 'displayBlock' );
    $( chapter ).find( '.infoSizeButton' ).addClass( 'appear' );  
  }

  function closeSize() {
    isInfoOpen = false;

    $( chapter ).find( '.infoSizeContainer' ).removeClass( 'infoOpen' );
    $( chapter ).find( '.infoSizeButton' ).removeClass( 'infoOpen' );
    $( chapter ).find( '.infoSizeWrapper' ).removeClass( 'displayBlock' );
  }

  function closeAll() {
    close();
    closeSize();
  }

  return {
    close: closeAll,
  }

};
